import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Field, Formik, Form as FormFormik } from 'formik';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './styles';
import Selector from '../../../Selector';
import { OutlineTextField } from '../../../FormikCustoms';

const validateForm = (values) => {
  const errors = {};

  if (!values.branch) {
    errors.branch = "A Filial é necessária.";
  }

  if (parseInt(values.quantity) <= 0) {
    errors.quantity = "A quantidade deve ser maior que 0";
  }

  return errors;
};

const Form = ({ branches, onSubmit }) => {

  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [buttonSize, setButtonSize] = useState(0);
  const buttonRef = useRef(null);

  useEffect(() => {
    const { clientHeight, clientWidth } = buttonRef.current;
    setButtonSize(Math.min(clientHeight, clientWidth));
  }, []);

  const onSubmitWithLoading = useCallback(async (payload) => {
    setLoading(true);
    try {
      await onSubmit(payload);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }

  }, [setLoading, onSubmit]);

  const handleConfirm = async (errorCallback, values) => {
    try {
      await onSubmitWithLoading(values);
    } catch (e) {
      errorCallback();
    }
  };

  return (
    <Formik
      initialValues={{
        branch: null,
        quantity: 0,
      }}
      validateOnMount
      validate={(values) => validateForm(values)}
      onSubmit={(values, { setValues, _setSubmiting }) => {
        handleConfirm(() => setValues({}), values);
      }}
    >
      {({ submitForm, isSubmiting, values, setValues }) => (
        <FormFormik>
          <Grid container direction="column">
            <Grid item={true} md={4} xs={4}>
              <Field
                component={Selector}
                options={branches}
                isClearable
                width='100%'
                placeholder='Selecione uma filial'
                name="branch"
                required
                value={values.branch}
                onChange={(branch) => setValues({ ...values, branch })}
              />
            </Grid>

            <Grid item={true} md={6} xs={6} style={{ paddingTop: 20 }}>
              <IconButton
                className={classes.quantityPadding}
                onClick={() => setValues({ ...values, quantity: values.quantity > 0 ? values.quantity-1 : 0 })}
              >
                <RemoveIcon fontSize="small" color="primary" />
              </IconButton>
              <Field
                component={OutlineTextField}
                variant="outlined"
                type="number"
                label="Quantidade"
                name="quantity"
                className={classes.quantityField}
                value={values.quantity}
                required
                style={{
                  width: 'inherit'
                }}
                onChange={(e) => {
                  setValues({ ...values, quantity: e.target.value ? parseInt(e.target.value) : 0 });
                }}
              />
              <IconButton
                  className={classes.quantityPadding}
                  onClick={() => setValues({ ...values, quantity: values.quantity+1 })}
              >
                <AddIcon fontSize="small" color="primary" />
              </IconButton>
            </Grid>

            <Grid item={true} md={2} xs={2} style={{ paddingTop: 20 }}>
              <Button
                ref={buttonRef}
                color="primary"
                variant="contained"
                size="large"
                className={classes.btns}
                disabled={isSubmiting || loading}
                onClick={submitForm}
              >
                {loading ? <CircularProgress size={0.7 * buttonSize} /> : 'Chamar'}
              </Button>
            </Grid>
          </Grid>
        </FormFormik>
      )}
    </Formik>
  );
};

export default Form;
